import FeatureList, { Feature } from "./FeatureList";

export default FeatureList;
export { Feature };
